import { BreadCrumb } from "primereact/breadcrumb";
import { routes } from "../../../routes";
import { useEffect, useRef, useState } from "react";
import { FilterMatchMode } from "primereact/api";
import SearchComponent from "../../../components/datatable/SearchComponent";
import { Button } from "primereact/button";
import ActionBtn from "../../../components/dashboard/btn/ActionBtn";
import GeneralTestService from "../../../api/GeneralTestService";
import TrainingService from "../../../api/TrainingService";
import { Toast } from "primereact/toast";
import DeleteConfirmation from "../../../components/modal/DeleteConfirmation";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { TextInput } from "../../../components/formLibs/FormLibs";
import { ProgressSpinner } from "primereact/progressspinner";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputTextarea } from "primereact/inputtextarea";
import { useNavigate, useParams } from "react-router-dom";
import ProposalService from "../../../api/ProposalService";
import { RadioButton } from "primereact/radiobutton";

const TestProposal = () => {
  const [proposals, setProposals] = useState([]);
  const [proposal, setProposal] = useState();
  const { id } = useParams();
  const items = [
    {
      label: "Test de developpement Personnel",
      url: routes.dashboard.generalTest.path,
    },
    {
      label: "Réponses",
      url: routes.dashboard.proposals.path,
    },
    { label: "Liste" },
  ];
  const candidate = {
    icon: "pi pi-wallet",
    url: routes.dashboard.defaultPath,
  };
  const [selectedAnswer, setSelectedAnswer] = useState("");

  const [classroom, setClassroom] = useState("");
  const [refresh, setRefresh] = useState(true);
  const [loading, setLoading] = useState(true);

  const [answer, setAnswer] = useState("");
  const toast = useRef(null);
  const [confirm, setConfirm] = useState(false);
  const [addVisible, setAddVisible] = useState(false);
  const [updateVisible, setUpdateVisible] = useState(false);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    //name: { value: null, matchMode: FilterMatchMode.STARTS_WITH }
  });

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };
  const header = () => {
    return (
      <div className="flex justify-content-between">
        <Button
          icon="pi pi-plus"
          label="Ajouter une proposition"
          onClick={() => setAddVisible(true)}
        />
        <SearchComponent
          globalFilterValue={globalFilterValue}
          onGlobalFilterChange={onGlobalFilterChange}
        />
      </div>
    );
  };

  const actionTemplate = (rowData) => {
    return (
      <div className="flex flex-wrap justify-content-start gap-3">
        {
          <ActionBtn
            icon="pi pi-pencil"
            severity="info"
            tooltip="Modifier"
            handleClick={() => updateProposal(rowData)}
          />
        }
        <ActionBtn
          icon="pi pi-trash"
          severity="danger"
          tooltip="Supprimer"
          handleClick={() => confirmDelete(rowData.id)}
        />
      </div>
    );
  };

  const updateStatus = (e, rowData) => {
    console.log("e.value", e.value);
    let data = rowData;
    data.status = e.value == "Oui" ? "yes" : "no";
    GeneralTestService.update(rowData.id, data).then((res) => {
      setRefresh(!refresh);
    });
  };
  const updateProposal = (rowData) => {
    GeneralTestService.update(rowData.id, rowData).then((res) => {
      setRefresh(!refresh);
    });
  };

  const addProposal = (e) => {
    e.preventDefault();
    if (selectedAnswer == "" || !answer) {
      toast.current.show({
        severity: "error",
        summary: "Stop",
        detail: "Veuillez remplir tous les champs",
        life: 3000,
      });
    } else {
      const data = {
        proposal: answer,
        isOk: selectedAnswer == "true" ? true : false,
        general_test_id: id,
      };
      ProposalService.create(data)
        .then((res) => {
          //console.log("res", res)
          setRefresh(!refresh);
          setAddVisible(false);
        })
        .catch((err) => console.log("err", err));
    }
  };
  const deleteTest = () => {
    ProposalService.delete(proposal)
      .then((res) => {
        toast.current.show({
          severity: "info",
          summary: "Succèss",
          detail: "Réponse supprimée avec succès",
          life: 3000,
        });
        setRefresh(!refresh);
      })
      .catch((err) => {});
  };
  const rejectConfirmation = () => {
    toast.current.show({
      severity: "warn",
      summary: "Annulé",
      detail: "Vous aviez annulé la suppression",
      life: 3000,
    });
  };
  const confirmDelete = (id) => {
    setProposal(id);
    setConfirm(true);
  };

  useEffect(() => {
    setLoading(true);
    ProposalService.getAll(id).then((res) => {
      setProposals(res.data.testProposals);
      setLoading(false);
    });
  }, [refresh]);

  return (
    <div>
      <Toast ref={toast} />
      <DeleteConfirmation
        visible={confirm}
        onHide={() => setConfirm(false)}
        message={`Voulez-vous réellement supprimé la proposition de réponse ${
          proposals?.filter((rol) => rol.id === parseInt(proposal))[0]?.proposal
        } ?`}
        accept={deleteTest}
        reject={rejectConfirmation}
      />
      <Dialog
        header="Ajouter une proposition"
        visible={addVisible}
        style={{ width: "50vw" }}
        onHide={() => setAddVisible(false)}
      >
        <form className="form" onSubmit={addProposal}>
          <div className="form__item">
            <label htmlFor="name">Réponse</label>
            <div className="form__item__ic_p">
              <TextInput
                type="text"
                name="name"
                label="name"
                handleChange={(e) => setAnswer(e.target.value)}
                // register={register}
              />
            </div>
          </div>
          <div className="flex align-items-center my-3">
            <label htmlFor="name">Statut :</label>
            <div>
              <div className="flex align-items-center justify-content-evenly mx-4">
                <div className="flex align-items-center mr-3">
                  <RadioButton
                    inputId={"true"}
                    name="statut"
                    value={"true"}
                    // {...register}
                    //inputRef={register.ref}
                    onChange={(e) => {
                      console.log("====================================");
                      console.log(e.value);
                      console.log("====================================");
                      setSelectedAnswer(e.value);
                    }}
                    checked={selectedAnswer == "true"}
                  />
                  <label htmlFor={"true"} className="ml-2 mr-2">
                    Vrai
                  </label>
                </div>
                <RadioButton
                  inputId={"false"}
                  name="statut"
                  value={"false"}
                  /* {...register}
                  inputRef={register.ref} */
                  onChange={(e) => setSelectedAnswer(e.value)}
                  checked={selectedAnswer == "false"}
                />
                <label htmlFor={"false"} className="ml-2">
                  Faux
                </label>
              </div>
            </div>
          </div>
          <div className="form__item">
            <button type="submit">
              Enregistrer{" "}
              <ProgressSpinner
                style={
                  loading
                    ? { width: "20px", height: "20px" }
                    : { width: "0px", height: "0px" }
                }
                strokeWidth="8"
                loading={loading}
              />
            </button>
          </div>
        </form>
      </Dialog>
      <div>
        <BreadCrumb model={items} home={candidate} />
      </div>
      <div>
        <div>
          <DataTable
            header={header}
            value={proposals}
            tableStyle={{ minWidth: "50rem" }}
            loading={loading}
            loadingIcon={
              <i
                className="pi pi-spin pi-spinner"
                style={{ fontSize: "2rem" }}
              ></i>
            }
          >
            <Column field="proposal" header="Réponse"></Column>
            <Column
              field="isOk"
              header="Statut"
              body={(row) => (row.isOk ? "Vrai" : "Faux")}
            ></Column>
            <Column header="Actions" body={actionTemplate}></Column>
          </DataTable>
        </div>
      </div>
    </div>
  );
};

export default TestProposal;
